
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "getVersion", () => $eb7869949b641a40$export$c506eb22e615ba4a);
$parcel$export(module.exports, "parse", () => $eb7869949b641a40$export$98e6a39c04603d36);
$parcel$export(module.exports, "find", () => $eb7869949b641a40$export$71aa6c912b956294);
$parcel$export(module.exports, "map", () => $eb7869949b641a40$export$871de8747c9eaa88);
/**
 * AGS parser
 *
 * @version 4.0.1
 * @author Charlie LEDUC <contact@pixeliste.fr>
 */ /**
 * AGS3.x parser
 *
 * @version 4.0.1
 * @author Charlie LEDUC <contact@pixeliste.fr>
 */ /**
 * Utils
 *
 * @version 4.0.0
 * @author Charlie LEDUC <contact@pixeliste.fr>
 */ function $533342404bccfdc5$export$20c071b7401cef3(value) {
    return /\d{4}-\d{2}-\d{2}/g.test(value);
}
function $533342404bccfdc5$export$5d452d25893c9ae2(value) {
    return /^[\d.,]+$/g.test(value);
}
function $533342404bccfdc5$export$26e0507334599a1e(value) {
    return /[a-zA-Z\/-]+/g.test(value);
}
function $533342404bccfdc5$export$5e4751563059a4b6(value, decimal) {
    const r = Math.pow(10, decimal ?? 1);
    let v = value ?? 0;
    if (isNaN(v) || !isFinite(v)) v = 0;
    return Math.round(v * r) / r;
}
function $533342404bccfdc5$export$837bd02682cd3db9(content) {
    const blocks = [];
    if (!content || typeof content !== "string") return blocks;
    const groups = content.split(/(\r\n|\n\r|\n){2,}/gm);
    for(let i = 0; i < groups.length; i++){
        const group = groups[i].trim();
        if (!group.length) continue;
        const rows = group.split(/\n/gm).map((row)=>row.split(/",/g).map((cell)=>cell.trim().replace(/^(")|(")$/g, "")));
        blocks.push(rows);
    }
    return blocks;
}


function $f38ff2d8f5ea5e99$export$2e2bcd8739ae039(content) {
    const groups = [];
    const blocks = (0, $533342404bccfdc5$export$837bd02682cd3db9)(content);
    for(let i = 0; i < blocks.length; i++){
        let heading = "";
        const block = blocks[i];
        const headers = [];
        const data = [];
        for(let j = 0; j < block.length; j++){
            const row = block[j];
            if (row.length < 1) continue;
            const firstCell = row[0] ?? "";
            if (firstCell.indexOf("**") > -1) heading = firstCell.replace(/[?*]/g, "").trim();
            else if (firstCell.charAt(0) === "*") for(let k = 0; k < row.length; k++){
                const cell = row[k];
                headers.push({
                    name: cell.length ? cell.replace(/[?*]/g, "").trim() : "undefined",
                    unit: "",
                    type: ""
                });
            }
            else if (firstCell === "<UNITS>") for(let k = 0; k < row.length; k++){
                const cell = row[k];
                if (k < headers.length) headers[k].unit = cell.length ? cell.trim() : "";
            }
            else {
                const cont = firstCell === "<CONT>" && data.length > 0;
                const cells = [];
                for(let k = 0; k < row.length; k++){
                    const cell = row[k];
                    const value = cell && cell.length ? cell : "";
                    const header = k < headers.length ? headers[k] : {
                        name: "undefined"
                    };
                    const unit = header.unit ?? "";
                    if (unit === "dd/mm/yyyy") {
                        const parts = value.split("/");
                        cells.push(parts.length === 3 ? `${parts[2].trim()}-${parts[1].trim()}-${parts[0].trim()}` : null);
                    } else if (unit === "yyyy-mm-dd") {
                        const parts = value.split("-");
                        cells.push(parts.length === 3 ? `${parts[0].trim()}-${parts[1].trim()}-${parts[2].trim()}` : null);
                    } else if (!value.length) cells.push(null);
                    else if ((0, $533342404bccfdc5$export$5d452d25893c9ae2)(value)) cells.push((0, $533342404bccfdc5$export$5e4751563059a4b6)(parseFloat(value.trim()), 5));
                    else cells.push(value);
                }
                if (cont) {
                    const prev = data[data.length - 1];
                    for(let k = 1; k < cells.length; k++){
                        const cell = cells[k] ?? "";
                        if (cell !== null) {
                            if (k < prev.length) prev[k] = `${prev[k] ?? ""}${cell}`;
                        }
                    }
                } else {
                    if (headers.length < cells.length) while(headers.length < cells.length)headers.push({
                        name: `${heading}_${headers.length}`,
                        unit: "",
                        type: ""
                    });
                    if (cells.length < headers.length) while(cells.length < headers.length)cells.push(null);
                    data.push(cells);
                }
            }
        }
        if (heading.length) groups.push({
            heading: heading,
            columns: headers,
            rows: data
        });
    }
    return groups;
}


/**
 * AGS4.x parser
 *
 * @version 4.0.1
 * @author Charlie LEDUC <contact@pixeliste.fr>
 */ 
function $4b22d199a6f831f2$export$2e2bcd8739ae039(content) {
    const groups = [];
    const blocks = (0, $533342404bccfdc5$export$837bd02682cd3db9)(content);
    for(let i = 0; i < blocks.length; i++){
        let heading = "";
        const block = blocks[i];
        const headers = [];
        const data = [];
        for(let j = 0; j < block.length; j++){
            const row = block[j];
            if (row.length < 2) continue;
            const firstCell = row[0] ?? "";
            if (firstCell === "GROUP") heading = (row[1] ?? "").trim();
            else if (firstCell === "HEADING") for(let k = 1; k < row.length; k++){
                const cell = row[k];
                headers.push({
                    name: cell.length ? cell.trim() : "undefined",
                    unit: "",
                    type: ""
                });
            }
            else if (firstCell === "UNIT") for(let k = 1; k < row.length; k++){
                const cell = row[k];
                if (k - 1 < headers.length) headers[k - 1].unit = cell.length ? cell.trim() : "";
            }
            else if (firstCell === "TYPE") for(let k = 1; k < row.length; k++){
                const cell = row[k];
                if (k - 1 < headers.length) headers[k - 1].type = cell.length ? cell.trim() : "";
            }
            else if (firstCell === "DATA") {
                const cells = [];
                for(let k = 1; k < row.length; k++){
                    const cell = row[k];
                    const value = cell.length ? cell.trim() : "";
                    const header = k - 1 < headers.length ? headers[k - 1] : {
                        name: "undefined"
                    };
                    const type = header.type ?? "";
                    if (type === "DT") cells.push((0, $533342404bccfdc5$export$20c071b7401cef3)(value) ? value : null);
                    else if (type === "DMS") cells.push(value.length ? value : null);
                    else if (type.indexOf("DP") > -1 || type.indexOf("SP") > 1) // const dp = Number.parseInt(type.replace(/\D+/g, ''))
                    cells.push(value.length ? (0, $533342404bccfdc5$export$5e4751563059a4b6)(Number.parseFloat(value), 5) : null);
                    else if (type === "X" || type === "ID") cells.push(value.length ? value : null);
                    else if ((0, $533342404bccfdc5$export$5d452d25893c9ae2)(value)) cells.push(value.length ? (0, $533342404bccfdc5$export$5e4751563059a4b6)(Number.parseFloat(value), 5) : null);
                    else cells.push(value.length ? value : null);
                }
                if (headers.length < cells.length) while(headers.length < cells.length)headers.push({
                    name: `${heading}_${headers.length}`,
                    unit: "",
                    type: ""
                });
                if (cells.length < headers.length) while(cells.length < headers.length)cells.push(null);
                data.push(cells);
            }
        }
        if (heading.length) groups.push({
            heading: heading,
            columns: headers,
            rows: data
        });
    }
    return groups;
}


function $eb7869949b641a40$export$c506eb22e615ba4a(content) {
    return content.indexOf("**PROJ") > -1 ? 3 : 4;
}
function $eb7869949b641a40$export$98e6a39c04603d36(content) {
    const version = content.indexOf("**PROJ") > -1 ? 3 : 4;
    return version === 3 ? (0, $f38ff2d8f5ea5e99$export$2e2bcd8739ae039)(content) : (0, $4b22d199a6f831f2$export$2e2bcd8739ae039)(content);
}
function $eb7869949b641a40$export$71aa6c912b956294(heading, groups) {
    if (!groups.length) return null;
    const i = groups.findIndex((group)=>group.heading === heading);
    return i > -1 ? groups[i] : null;
}
function $eb7869949b641a40$export$871de8747c9eaa88(group, keys) {
    return group.rows.map((row)=>{
        const values = {};
        keys.forEach((key)=>{
            const i = group.columns.findIndex((column)=>column.name === key.header);
            let value = i > -1 ? row[i] : null;
            if (key.format === "percent") {
                value = Number.parseFloat(value);
                values[key.name] = Number.isFinite(value) ? value / 100 : null;
            } else values[key.name] = value !== null ? value : key.default ?? null;
        });
        return values;
    });
}


//# sourceMappingURL=main.js.map
